import { displayFnWrapperArrayFlatter } from './common-display-fn';

export const emeaParkingRatioFunctions = {
  363: {
    // 363 - parking ratio (Poland & Finland)
    displayFn: displayFnWrapperArrayFlatter,
  },
  382: {
    // 382 - parking ratio (Italy)
    displayFn: displayFnWrapperArrayFlatter,
  },
  468: {
    // 468 - parking ratio (Norway)
    displayFn: displayFnWrapperArrayFlatter,
  },
  487: {
    // 487 - parking ratio (Norway)
    displayFn: displayFnWrapperArrayFlatter,
  },
  449: {
    // 449 - parking ratio (Sweden)
    displayFn: displayFnWrapperArrayFlatter,
  },
};
